export const quickAccessSchedulerPost = {
    accessorId: '#quick-access-create-post',
    event: 'mixpanel_post_creation_started',
    eventValue: { origin: 'quick_access' }
} as const;

export const mediaLibraryCreateSchedulerPost = {
    accessorId: '#media-library-create-post',
    event: 'mixpanel_post_creation_started',
    eventValue: { origin: 'media_library' }
} as const;
